// Libraries
import { FormElems } from '../../components';
import axislogo from '../../static/images/fc-logo-03.png';
import errorImage from '../../static/images/unexpected-error.png';
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Components

// Images

// Styles
import './errorPage.scss';

const ErrorPage = props => {
    const { error, resetErrorBoundary } = props;
    const history = useHistory();

    // Handle function on home button click
    function handleBack() {
        history.push('/');
        resetErrorBoundary && resetErrorBoundary();
    }

    // Handle function on try agin button click
    function handleAgain() {
        history.push('/');
        setTimeout(() => {
            window.location.reload();
        }, 100);
        resetErrorBoundary && resetErrorBoundary();
    }
    return (
        <div className="error-page-wrap">
            <div className="logo-wrap">
                <img src={axislogo} alt="axis bank" />
            </div>
            <div className="error-section">
                <div className="error-image">
                    <img src={errorImage} alt="Unexpected error" />
                </div>
                <h1 className="error-heading">Unexpected Error</h1>
                <p className="info">
                    {error ||
                        `Unable to process the request. Please try again after some
                    time`}
                </p>
                <div className="action-btn">
                    {error ? (
                        <FormElems.Button
                            buttonType="secondary"
                            text="Go to Home"
                            type="button"
                            handleClick={handleBack}
                        />
                    ) : (
                        <FormElems.Button
                            buttonType="secondary"
                            text="Try Again"
                            type="button"
                            handleClick={handleAgain}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

ErrorPage.propTypes = {
    error: PropTypes.object,
    resetErrorBoundary: PropTypes.func,
};

export default ErrorPage;
